/**
 * Format a number based on the specified format type
 *
 * @param value - The numeric value to format
 * @param format - Optional format type: 'currency', 'percentage', or 'year'
 * @returns Formatted string representation of the number
 */
export function formatNumber(value: number | null | undefined, format?: string): string {
  if (value === null || value === undefined) return '';

  if (format === 'currency') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  if (format === 'percentage') {
    return `${value}%`;
  }

  if (format === 'year') {
    return value.toString();
  }

  return new Intl.NumberFormat('en-US').format(value);
}
